import { constants as config, features as featuresConfig } from '@config';
import { aiWrite as aiWriteFeature } from 'src/services/features';

import { pascalize } from '../utils/humps';

import defaultMenus from './element-popupmenu/content/default-menus.json';
import { openToolMenuTab } from './tool-menu/helpers';
import FileMenu from './top-submenu/contents/file/view';
import createLayoutButton from './top-submenu/contents/layout-button/layout-button';

const specificMenuIds = ['text', 'table', 'video', 'logo', 'icon', 'layout', 'image', 'sticker', 'group',
  'multiselect', 'background', 'root', 'bleed', 'locked', 'link', 'qrcode'];

const getElementMenuId = (elem) => {
  let menuId;
  if (elem.tagName === 'g' || $(elem).closest('g').is('.background') || $(elem).is('.logo')) {
    menuId = INKIVE.DesignFacade.getType(elem);
  } else if ($(elem).hasClass('layoutClipperImage')) {
    menuId = 'layout';
  } else if (elem.tagName === 'a') {
    menuId = $(elem).hasClass('video') ? 'video' : 'link';
  } else {
    menuId = elem.tagName;
  }

  return specificMenuIds.includes(menuId) ? menuId : 'misc';
};

const allElementsHaveMenu = (selectedElements, menu) => selectedElements.reduce((bool, elem) => {
  let menuId = getElementMenuId(elem);
  menuId = (specificMenuIds.includes(menuId) ? pascalize(menuId) : menuId).toUpperCase();
  const defaultMenu = (typeof menuId === 'string' && defaultMenus[menuId]) || defaultMenus.DEFAULT;
  return bool && defaultMenu && defaultMenu.includes(menu);
}, true);

module.exports = {
  getElementMenuId,
  populateMenuItems: function () {
    this.simplified = INKIVE.Menus.showSimplifiedRestrictions;
    const selectedElements = this.canvas.getSelectedElems();
    const $handledElement = $(this.handledElement);
    const elem = INKIVE.DesignFacade.get(this.handledElement.id);
    this.items = {};

    if (this.canvas.getMode() !== 'textedit') {
      this.copiedText = null;
    }

    if (elem?.type === 'text' && aiWriteFeature.isFeatureEnabled()) {
      const isProPaidUser = INKIVE.UserInfoFactory.isProPaidUser();
      const iconName = isProPaidUser ? featuresConfig.aiWrite.contextMenu.proUserIcon : featuresConfig.aiWrite.contextMenu.freeUserIcon;
      this.items.ai_write = {
        name: INKIVE.TranslateHelper.translate('ai_write.title'),
        icon: this.setCustomIcon(iconName, true),
        disabled: $handledElement.is('.locked'),
        className: 'context-menu-item--ai-write'
      };

      this.items.ai_sep = config.contextMenu.separator;
    }

    // TODO: use AI Image feature flag when it's available
    if (elem?.type === 'image' && aiWriteFeature.isFeatureEnabled()) {
      const isProPaidUser = INKIVE.UserInfoFactory.isProPaidUser();
      const iconName = isProPaidUser ? featuresConfig.aiWrite.contextMenu.proUserIcon : featuresConfig.aiWrite.contextMenu.freeUserIcon;
      this.items.ai_image = {
        name: INKIVE.TranslateHelper.translate('ai_image.title'),
        icon: this.setCustomIcon(iconName, true),
        disabled: $handledElement.is('.locked'),
        className: 'context-menu-item--ai-image'
      };

      this.items.ai_sep = config.contextMenu.separator;
    }

    this.items.copy = {
      name: INKIVE.TranslateHelper.translate('editor.contextmenu.copy'),
      icon: this.setCustomIcon('duplicate---20', 'isSvg'),
      disabled: this.handledElement.id === 'svgroot' || (this.canvas.getMode() === 'textedit' && !this.getCopiedText())
    };

    this.items.cut = {
      name: INKIVE.TranslateHelper.translate('editor.contextmenu.cut'),
      icon: this.setCustomIcon('cut', 'isSvg'),
      disabled: this.handledElement.id === 'svgroot' || (this.canvas.getMode() === 'textedit' && !this.getCopiedText())
    };

    this.items.paste = {
      name: INKIVE.TranslateHelper.translate('editor.contextmenu.paste'),
      icon: this.setCustomIcon('paste', 'isSvg'),
      disabled: !($(this.handledElement).is('#svgroot') || this.canvas.getMode() === 'textedit')
    };

    const smartAssetTab = document.querySelector("[href='#tabPlaceholders']");
    if (elem?.type === 'text' && !!smartAssetTab) {
      this.items.smart_asset_separator = config.contextMenu.separator;

      this.items.remove_smart_asset = {
        name: INKIVE.TranslateHelper.translate('editor.contextmenu.remove_smart_asset'),
        icon: this.setCustomIcon('unlink-smart-asset', true),
        disabled: $handledElement.is('.locked'),
        className: 'context-menu-item--remove-smart-asset'
      };

      this.items.smart_asset = {
        name: INKIVE.TranslateHelper.translate('editor.contextmenu.apply_smart_asset'),
        icon: this.setCustomIcon('vector---pencil', true),
        disabled: $handledElement.is('.locked'),
        className: 'context-menu-item--smart-asset'
      };
    }

    if (elem?.type === 'text' && INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.TEMPLATE) {
      this.items.brand_asset = {
        name: INKIVE.TranslateHelper.translate('editor.contextmenu.apply_brand_asset'),
        icon: this.setCustomIcon('briefcase---20', true),
        disabled: $handledElement.is('.locked'),
        className: 'context-menu-item--brand-asset'
      };
    }

    if (!($handledElement.is('#svgroot') || this.canvas.getMode() === 'textedit')) {
      this.items.sep1 = config.contextMenu.separator;

      this.items.fold_z_index = { name: INKIVE.TranslateHelper.translate('popupmenu.tooltip.order') };
      this.items.fold_z_index.items = {
        bring_to_front: {
          name: INKIVE.TranslateHelper.translate('popupmenu.tooltip.send_top'),
          icon: this.setCustomIcon('normal', 'isSvg')
        },
        send_to_back: {
          name: INKIVE.TranslateHelper.translate('popupmenu.tooltip.send_bottom'),
          icon: this.setCustomIcon('upside-down', 'isSvg')
        },
        bring_item_forward: {
          name: INKIVE.TranslateHelper.translate('popupmenu.tooltip.send_forward'),
          icon: this.setCustomIcon('put-out', 'isSvg')
        },
        send_item_backwards: {
          name: INKIVE.TranslateHelper.translate('popupmenu.tooltip.send_backward'),
          icon: this.setCustomIcon('put-in', 'isSvg')
        }
      };

      if (INKIVE.C.BOOK.book_type !== INKIVE.C.BOOK_TYPE.RESTRICTED_DESIGN) {
        this.items.sep2 = config.contextMenu.separator;

        const allSelectedElementsHaveGroup = allElementsHaveMenu(selectedElements, 'GROUP_GROUP');

        this.items.group = {
          name: INKIVE.TranslateHelper.translate('popupmenu.dropdown_title.group_group'),
          icon: this.setCustomIcon('group---20', 'isSvg'),
          disabled: selectedElements.length === 1 || !allSelectedElementsHaveGroup
        };

        this.items.ungroup = {
          name: INKIVE.TranslateHelper.translate('popupmenu.dropdown_title.group_ungroup'),
          icon: this.setCustomIcon('ungroup---20', 'isSvg'),
          disabled: (selectedElements.length !== 1 || !$handledElement.is('.group') || !allSelectedElementsHaveGroup)
        };
      }

      this.items.sep3 = config.contextMenu.separator;

      this.items.lock_movement = {
        name: INKIVE.TranslateHelper.translate('editor.contextmenu.lock_movement'),
        icon: this.setCustomIcon('lock---20', 'isSvg'),
        disabled: $handledElement.is('.locked')
      };

      this.items.unlock_movement = {
        name: INKIVE.TranslateHelper.translate('editor.contextmenu.unlock_movement'),
        icon: this.setCustomIcon('unlock---20', 'isSvg'),
        disabled: !$handledElement.is('.locked')
      };

      this.getAddToLibraryProperties(selectedElements[0]);

      switch (INKIVE.C.BOOK.book_type) {
        case INKIVE.C.BOOK_TYPE.TEMPLATE:
          this.items.sep4 = config.contextMenu.separator;
          this.items.add_to_brand_assets = {
            name: INKIVE.TranslateHelper.translate('editor.contextmenu.add_to_brand_assets'),
            icon: this.setCustomIcon('briefcase---20', 'isSvg'),
            disabled: !this.isAddToLibraryAllowed
          };

          this.items.sep5 = config.contextMenu.separator;
          this.items.restrict = {
            name: INKIVE.TranslateHelper.translate(
              this.simplified
                ? 'popupmenu.tooltip.restrict_changes'
                : 'editor.contextmenu.restrict'),
            icon: this.setCustomIcon(this.simplified
              ? 'key'
              : 'restrict---20', 'isSvg'
            , this.simplified)
          };

          break;

        case INKIVE.C.BOOK_TYPE.DESIGN:
        case INKIVE.C.BOOK_TYPE.DESYGNER_DESIGN:
        case INKIVE.C.BOOK_TYPE.RESTRICTED_DESIGN:
          this.items.sep4 = config.contextMenu.separator;
          this.items.add_to_personal_library = {
            name: INKIVE.TranslateHelper.translate('editor.contextmenu.add_to_personal_library'),
            icon: this.setCustomIcon('desygner-icon-folder'),
            disabled: !this.isUserPremium || !this.isAddToLibraryAllowed
          };

          break;
      }

      const $bgRemovalButton = $('li > a[data-action="on_bgRemoval"]');
      if ($bgRemovalButton.is(':visible') && ['image', 'background'].includes(elem.type)) {
        this.items.sep6 = config.contextMenu.separator;
        this.items.remove_background = {
          name: INKIVE.TranslateHelper.translate('popupmenu.dropdown_title.background_bg_removal'),
          icon: this.setCustomIcon('bg-removal', true),
          disabled: elem.background_removed
        };
      }
    }
  },
  items: {},
  handledElement: null,
  handledNode: null,
  canvas: null,
  isUserPremium: false,
  lastAction: null,
  textArea: null,

  copiedText: null,

  handleContextMenu: function (event) {
    this.editor = this.editor || INKIVE.Tool.getInstance().editor;
    this.canvas = this.editor.canvas;
    this.textArea = $(this.editor.curConfig.initText.input).get(0);
    const selectedElems = [...this.canvas.getSelectedElems()];

    this.destroyMenu();

    this.canvas.addToSelection(selectedElems);
    this.getHandledElement(event);

    if (!(event.button === 2 || (event.button === 0 && event.ctrlKey))) {
      return;
    }

    if (this.handledElement) {
      handleElementMenu.call(this);
    } else if (this.handledNode) {
      handleNodeMenu.call(this);
    }

    function handleElementMenu () {
      if ($(this.handledElement).data('external_source') === INKIVE.C.SHUTTERSTOCK) return;

      this.handledElement.id === 'svgroot' || this.canvas.selectorManager.requestSelector(this.handledElement)
        .showGrips(false);

      INKIVE.UserInfoFactory.get().then(_.bind(function (userInfo) {
        this.isUserPremium = _(userInfo.roles).contains('ROLE_PREMIUM');
        this.populateMenuItems();
        this.applyRestrictions();

        $.contextMenu({
          selector: '#' + this.handledElement.id,
          build: _.bind(function ($trigger, e) {
            return {
              callback: _.bind(function (key, options) {
                this.handleCallback(key, options, e);
              }, this),
              items: this.items
            };
          }, this)
        });

        $(this.handledElement).contextMenu(true);
      }, this));
    }

    function handleNodeMenu () {
      const units = $(this.handledNode).data('units') || 'px';
      const runExtensions = _.bind(this.canvas.runExtensions, this, 'updateUnits');
      const items = {
        px: { name: 'Pixels' },
        in: { name: 'Inches' },
        cm: { name: 'Centimeters' },
        mm: { name: 'Milimeters' }
      };

      items[units].icon = this.setCustomIcon('fa fa-check');

      $.contextMenu({
        selector: '#' + this.handledNode.id,
        build: function ($trigger, e) {
          return {
            items,
            callback: runExtensions
          };
        }
      });
    }
  },

  destroyMenu: function () {
    this.editor = this.editor || INKIVE.Tool.getInstance().editor;
    this.canvas = this.editor.canvas;

    $.contextMenu('destroy');
    $('.context-menu-active').removeClass('context-menu-active');
    $('.desygner-clear-button').blur();
    this.canvas.clearSelection();

    this.fileMenu = new FileMenu({ recreated: true });
    this.layoutMenu = createLayoutButton();
  },

  setCustomIcon: function (icon, isSvg) {
    return function (opt, $itemElement, itemKey, item) {
      $itemElement.html((isSvg
        ? '<icon class="svg_icon"><svg><use xlink:href="#' + icon + '"></use></svg></icon>'
        : '<i class="' + icon + '"></i>') + '<span>' + item.name + '</span>');
    };
  },

  getAddToLibraryProperties: function (elem) {
    this.isAddToLibraryAllowed = INKIVE.PopupMenuDefault.prototype.isAddtoLibraryAvailable();
  },

  handleCallback: function (key, options, event) {
    switch (key) {
      case 'lock_movement':
      case 'unlock_movement':
        INKIVE.DesignFacade.set({ locked: key === 'lock_movement' });
        INKIVE.Menus.elementPopupMenu.refresh();

        break;

      case 'copy':
      case 'cut':
        this.cutCopySelectedText(key);
        break;

      case 'paste':
        if (this.canvas.getMode() === 'textedit') {
          this.redrawText(true);
        } else {
          if (this.canvas.clipBoard.length || this.copiedText) {
            this.canvas.pasteElements('icon-context-menu', this.canvas.lastClickPoint.x, this.canvas.lastClickPoint.y);
          } else {
            INKIVE.EditorFacade.canvas.call('advice.show', 'empty-clipboard-on-paste');
          }
        }
        break;
      case 'group':
        INKIVE.DesignFacade.create('group');
        break;

      case 'ungroup':
        INKIVE.DesignFacade.handle('ungroup');
        this.canvas.clearSelection();
        break;

      case 'bring_to_front':
        INKIVE.DesignFacade.handle(this.handledElement.id, 'send_top');
        break;

      case 'send_to_back':
        INKIVE.DesignFacade.handle(this.handledElement.id, 'send_bottom');
        break;

      case 'bring_item_forward':
        INKIVE.DesignFacade.handle(this.handledElement.id, 'send_forward');
        break;

      case 'send_item_backwards':
        INKIVE.DesignFacade.handle(this.handledElement.id, 'send_backward');
        break;

      case 'restrict':
        $(`.tool-menu li > a[href="#tab${this.simplified ? 'Simplified' : ''}Restrictions"]`).trigger('click');
        break;

      case 'add_to_personal_library':
      case 'add_to_brand_assets':
        {
          const $addButton = $('li > a[data-action="on_library_add_quiet"]');
          if ($addButton.is(':visible')) {
            $addButton.trigger('click');
          } else {
            $('li.editor-add-to-library > a[data-action="on_library_add"]').trigger('click');
          }
        }
        break;

      case 'remove_background':
        document.querySelector('[data-action="on_bgRemoval"]').classList.add('disabled');
        INKIVE.DesignFacade.handle('remove_background');
        break;

      case 'ai_write': {
        const callback = () => {
          const aiWriteTrigger = document.querySelector('.ai-write-cta button');
          const elementOptions = document.querySelector('#element-options');

          elementOptions && elementOptions.classList.remove('show');
          elementOptions && elementOptions.classList.add('out');

          aiWriteTrigger?.click();
        };

        openToolMenuTab('text', callback);

        break;
      }

      case 'ai_image': {
        const callback = () => {
          const aiImageTrigger = document.querySelector('.ai-image-cta button');
          const elementOptions = document.querySelector('#element-options');

          elementOptions && elementOptions.classList.remove('show');
          elementOptions && elementOptions.classList.add('out');

          aiImageTrigger?.click();
        };

        openToolMenuTab('Images', callback);

        break;
      }

      case 'smart_asset': {
        openToolMenuTab('Smart Assets');

        break;
      }

      case 'brand_asset': {
        const callback = () => {
          const brandAssetTrigger = document.querySelector("[data-key='library']");
          brandAssetTrigger?.click();
        };

        openToolMenuTab('text', callback);

        break;
      }

      case 'remove_smart_asset': {
        this.removeSmartAsset();
        break;
      }
    }

    this.lastAction = key;
  },

  getCopiedText: function () {
    return this.textArea.value.substring(this.textArea.selectionStart, this.textArea.selectionEnd);
  },

  removeSmartAsset: function () {
    const range = INKIVE.EditorFacade.canvas.runExtensions('selectionRange', {});
    const settings = { shouldRemoveOverlappedStyles: true, allowFalsyValue: true };
    const textarea = new INKIVE.Text.Textarea().setDOM(this.handledElement);

    textarea.text.setPartialStyling(range.start, range.end, config.smartAssets.attributes.userInput, '', settings);
    INKIVE.EditorFacade.canvas.runExtensions('renderTextArea', { textArea: textarea });
  },

  redrawText: function (isPaste) {
    let textValue;

    textValue = this.textArea.value.substring(0, this.textArea.selectionStart);

    if (isPaste) {
      this.copiedText || _.each(this.canvas.clipBoard, _.bind(function (elem) {
        const textarea = new INKIVE.Text.Textarea().setDOM(elem);
        if (textarea && textarea.text) {
          this.copiedText = textarea.text.textContent;
        }
      }, this));

      if (this.copiedText) {
        textValue += this.copiedText;
      } else {
        INKIVE.EditorFacade.canvas.call('advice.show', 'empty-clipboard-on-paste');
        return;
      }
    }

    const selectionPosition = textValue.length;

    textValue += this.textArea.value.substring(this.textArea.selectionEnd);

    this.textArea.value = textValue;
    this.textArea.selectionStart = this.textArea.selectionEnd = selectionPosition;

    this.textArea.dispatchEvent(new KeyboardEvent('paste'));
  },

  applyRestrictions: function () {
    const rf = INKIVE.RestrictionsFacade;

    if (!rf.canChange(this.handledElement, 'z_index')) {
      if (this.items.fold_z_index) this.items.fold_z_index.disabled = true;
    }

    if (!rf.canChange(this.handledElement, 'position')) {
      if (this.items.lock_movement) this.items.lock_movement.disabled = true;
      if (this.items.unlock_movement) this.items.unlock_movement.disabled = true;
      if (this.items.cut) this.items.cut.disabled = true;
    }

    if (!rf.canChange(this.handledElement, 'duplication')) {
      if (this.items.copy) this.items.copy.disabled = true;
      if (this.items.cut) this.items.cut.disabled = true;
    }

    if (!rf.canChange(this.handledElement, 'deletion')) {
      if (this.items.cut) this.items.cut.disabled = true;
    }

    const shouldDisableAiWrite = !rf.canChange(this.handledElement, 'change_content') || !rf.isFunctionalityAllowed('text_add');
    if (shouldDisableAiWrite && this.items.ai_write) {
      this.items.ai_write.disabled = true;
    }

    const shouldDisableAiImage = !rf.canChange(this.handledElement, 'image_content');
    if (shouldDisableAiImage && this.items.ai_image) {
      this.items.ai_image.disabled = true;
    }
  },

  getHandledElement: function (event) {
    const editor = INKIVE.Tool.getInstance().editor;
    const isContextMenuOpened = $(event.target).is('#context-menu-layer');
    let clickedElement = null;

    $('.element').each(function (i, elem) {
      if (editor.isElementClicked(elem, event)) {
        clickedElement = elem;
        if ($(clickedElement).parent().is('.sticker')) {
          clickedElement = document.querySelector('#' + elem.id).closest('.sticker');
        }
      }
    });

    this.handledElement = null;
    this.handledNode = null;

    if (!clickedElement || $(clickedElement).parent().is('.background') || clickedElement.parentElement.id === 'textmock') {
      this.canvas.clearSelection();
      this.handledElement = $('#svgroot')[0];
    } else {
      this.handledElement = clickedElement;
      const isAlreadySelected = _.contains(this.canvas.getSelectedElems(), clickedElement);

      isAlreadySelected || this.canvas.selectOnly([clickedElement], false);

      if (isContextMenuOpened) {
        this.canvas.selectorManager.requestSelector(this.handledElement).showGrips(true);
      }
    }
  },

  cutCopySelectedText: function (action) {
    if (this.canvas.getMode() === 'textedit') {
      this.copiedText = this.getCopiedText();
      action === 'cut' && this.redrawText(false);
    } else {
      // cutSelectedElements
      // copySelectedElements
      this.canvas[action + 'SelectedElements']();
    }
  }
};
